import clsx from 'clsx';
import { Circle } from './Circle';
import { baseButtonClass } from '../index';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
}

export const MenuApplications = ({ buttons, onClick }: Props) => {
  const getButton = (position: number) =>
    buttons.find((button) => button.order === position);

  const handlePress = (position: number) => {
    const button = getButton(position);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  return (
    <div
      className={clsx('col-span-full grid grid-cols-3 py-4', {
        'spacing-1': window.devicePixelRatio > 1,
        'spacing-4': window.devicePixelRatio <= 1,
      })}
    >
      <Circle
        disabled={Boolean(getButton(1)) === false}
        className="relative left mr-auto"
        label="VOD"
        size="md"
        onClick={() => handlePress(1)}
        onTouchEnd={() => handlePress(1)}
      />
      <button
        disabled={Boolean(getButton(2)) === false}
        className={clsx(baseButtonClass, 'h-7 mt-auto', {
          'scale-75': window.devicePixelRatio > 1,
        })}
        onClick={() => handlePress(2)}
        onTouchEnd={() => handlePress(2)}
      >
        MENU
      </button>
      <Circle
        disabled={Boolean(getButton(3)) === false}
        className="ml-auto"
        label="RECORDED"
        size="md"
        onClick={() => handlePress(3)}
        onTouchEnd={() => handlePress(3)}
      />
    </div>
  );
};
